<div>
  <span class="value" [style.width]="width" [style.backgroundColor]="background"></span>
  <span *ngIf="showGuide" class="guide" [class.valid]="valid" [class.invalid]="invalid" [style.left]="guideLeft" [style.width]="guideWidth"></span>
</div>

